import { IListItem } from '@/entities/list-item.interface';

export interface IAvpPeriod {
    index: number;
    from: number;
    to: number;
    payoutPhp: number;
    payoutDollars: number;
}

export function avpPeriodToListView(value: IAvpPeriod): IListItem {
    if (value.index === 0) {
        return { value: 0, heading: '0 sales' };
    } else {
        return {
            value: value.index,
            heading: `${value.from}${
                value.to < 1000 ? ' -' + value.to : '+'
            } sales`
        };
    }
}
